import { PathnameEnum } from '@constant';
import { useOutput } from '@hooks';
import { colorSet } from '@theme';
import { IImageListItem } from '@types';
import { Frame } from '../layout/Frame';
import { Text } from '../common/Text';
import { ImageModal } from '../feature/ImageModal';
import { ImageListItemComponent, LoadingSpinner } from '@components';

interface IOutputProps {
  padding?: string;
}

export const Output = (props: IOutputProps) => {
  const { padding = '48px 40px 96px 40px' } = props;

  const {
    locationPathname,
    data,
    isLoading,
    flattenImageList,
    outputBottomRef,
    createQueryStringForImageList,

    isImageModalVisible,
    imageModalType,
    selectedImageInfo,
    sequenceInfo,
    handleImageClick,
    handleImageModalClose,

    handleImageUseButtonClick
  } = useOutput();

  const isStandardOutput = locationPathname === PathnameEnum.STANDARD_OUTPUT_PAGE;
  const horizontalGap = isStandardOutput ? 15 : 10.4;
  const itemNumberPerRow = isStandardOutput ? 7 : 6;
  const sumOfHorizontalGaps = horizontalGap * (itemNumberPerRow - 1);
  const itemSize = `calc((100% - ${sumOfHorizontalGaps}px) / ${itemNumberPerRow})`;

  return (
    <>
      <Frame width="100%" padding={padding}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: `15px ${horizontalGap}px`,
            width: '100%',
            boxSizing: 'border-box'
          }}
        >
          {data &&
            flattenImageList().length > 0 &&
            flattenImageList().map((item: IImageListItem) => {
              return (
                <ImageListItemComponent
                  key={item.id}
                  item={item}
                  itemSize={itemSize}
                  onImageClick={handleImageClick}
                  onUseButtonClick={handleImageUseButtonClick}
                  createQueryStringForImageList={createQueryStringForImageList}
                />
              );
            })}
        </div>
        <div ref={outputBottomRef} />

        {(!data || flattenImageList().length === 0) && (
          <div
            style={{
              height: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <Text variant="body1" color={colorSet.gray500}>
                검색된 이미지가 없습니다.
              </Text>
            )}
          </div>
        )}
      </Frame>

      <ImageModal
        isVisible={isImageModalVisible}
        onClose={handleImageModalClose}
        initialImageModalType={imageModalType}
        initialSelectedImageInfo={selectedImageInfo}
        initialSequenceInfo={sequenceInfo}
        onUseButtonClick={handleImageUseButtonClick}
        createQueryStringForImageList={createQueryStringForImageList}
      />
    </>
  );
};
